'use client';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import { IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { forwardRef, useState, Fragment, useImperativeHandle } from 'react';
import { useShoppingCart } from '@/context/ShoppingCartContext';

import { useSpinnerContext } from '@/context/SpinnerContext';

import { MixpanelEventHub } from '@/services/eventEnums';
import { useTranslation } from 'react-i18next';
import { emitMixpanelEvents } from '../sider.utils';

export const MultipleOverlappingModal = forwardRef(function MultipleOverlappingModal(
  {
    setMultiProduct,

    removeLayerAndHighlightedCard,
  }: {
    setMultiProduct: any;

    removeLayerAndHighlightedCard: Function;
  },
  ref: React.ForwardedRef<any>
) {
  const {
    cartItems,

    disableBandsRef,
    disableConstellationRef,
    disableSrcRef,
    mergeOverlapRef,
    mergeOverlapPrimaryItemRef,
    multiProductCartItemRef,
  } = useShoppingCart();
  const { startLoaderEvent, stopLoaderEvent } = useSpinnerContext();
  const { t } = useTranslation('orderImagery');
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  // const [radioValue, setRadioValue] = useState('a');
  // const [radioValue2, setRadioValue2] = useState('a');

  // Tooltip states
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const openTooltip = Boolean(anchorEl);
  const id = openTooltip ? 'simple-popover' : undefined;

  useImperativeHandle(
    ref,
    () => {
      return {
        click1() {
          handleClickOpen1();
        },
        click2() {
          handleClickOpen2();
        },
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleClickToolTip = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(null);
    event.stopPropagation();
    event.preventDefault();

    setAnchorEl(event.currentTarget);
  };

  // const handleCloseToolTip = (event: any) => {
  //   event.stopPropagation();
  //   event.preventDefault();
  //   setAnchorEl(null);
  // };

  const handleClickOpen1 = async () => {
    setOpen(true);
  };

  const handleClickOpen2 = async () => {
    setOpen2(true);
  };

  // const handleRadioGroupChange = async (event: any, value: any) => {
  //   setRadioValue(value);
  // };

  // const handleRadioGroupChange2 = async (event: any, value: any) => {
  //   setRadioValue2(value);
  // };

  const handleClose = () => {
    // setOpenMultiProductDialog(false);
    setOpen(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  // const handleDialogContinueClick1 = (event: any) => {
  //   if (radioValue === 'a') {
  //     handleClose();
  //     setOpen2(true);
  //   } else {
  //     handleClose();
  //   }

  //   //fire the choice event here
  //   MixpanelTracking.getInstance().track(MixpanelEventHub.HUB_ORDER_ARCHIVE_MULTI_PRODUCT_CHOICE, {
  //     order_type: radioValue === 'b' ? 'multi_orders' : 'multi_product',
  //   });
  // };

  // const handleDialogContinueClick2 = async (event: any) => {
  //   triggerEvent(startLoaderEvent);
  //   mergeOverlapRef.current = true;
  //   disableSrcRef.current = cartItems[cartItems.length - 1].cardData.source;
  // disableBandsRef.current = cartItems[cartItems.length - 1].cardData.source.includes(K.LABELS.SOURCES.VANTOR)
  //     ? cartItems[cartItems.length - 1].cardData.bandsLength
  //     : '';
  //   disableConstellationRef.current = cartItems[cartItems.length - 1].cardData.source.includes(
  //     K.LABELS.SOURCES.VANTOR
  //   )
  //     ? cartItems[cartItems.length - 1].cardData.constellation
  //     : '';
  //   if (radioValue2 === 'a') {
  //     //union
  //     // await ConfirmMergeItemCart(
  //     //   cartItems.length - 2,
  //     //   cartItems.length - 1,
  //     //   MOSACIKING.STITCHED,
  //     //   coordinates
  //     // );
  //   } else if (radioValue2 === 'b') {
  //     //overlap once
  //     // await ConfirmMergeItemCart(
  //     //   cartItems.length - 2,
  //     //   cartItems.length - 1,
  //     //   MOSACIKING.UNSTITCHED,
  //     //   coordinates
  //     // );
  //   }

  //   //fire the choice event here
  //   MixpanelTracking.getInstance().track(MixpanelEventHub.Hub_Order_Archive_MULTI_PRODUCT_MOSAIC, {
  //     mosaic_type: radioValue2 === 'a' ? 'stitched' : 'unstitched',
  //   });

  //   triggerEvent(stopLoaderEvent);

  //   customToaster('Added to Cart', 'success');
  //   handleClose2();
  // };

  return (
    <Fragment>
      {/* <Button
        ref={ref}
        aria-hidden={true}
        hidden={true}
        variant="outlined"
        onClick={handleClickOpen}
      >
        Open Dialog
      </Button> */}

      {/* Dialog 1 is the option to choose if you want overlapping images seperately or not */}
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        className="skywatch-dialog multiple-overlape-dialogue overlapping-dialog"
        PaperProps={{
          sx: {
            maxWidth: '416px !important',
          },
        }}
      >
        <DialogTitle>{t('moTitle1')}</DialogTitle>
        <IconButton
          aria-label="close"
          className="close-btn"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 26,
            top: 20,
          }}
        >
          <CloseIcon />
        </IconButton>
        {/* This is multi product starting */}
        <DialogContent>
          <Typography variant="body1">{t('moTitle1.1')}</Typography>
          <Typography variant="body1">{t('moTitle2')}</Typography>
          {/* <Typography variant="body1">How would you like to proceed?</Typography> */}

          <Stack justifyContent="space-evenly" gap={3} direction="row">
            <Button
              name="continue-button"
              size="large"
              onClick={() => {
                setMultiProduct(false);
                handleClose();

                emitMixpanelEvents(MixpanelEventHub.HUB_ORDER_ARCHIVE_MULTI_PRODUCT_TOGGLE, {
                  toggle_status: 'on',
                  accept: 'cancel',
                });
              }}
              fullWidth
              variant="outlined"
              color="primary"
            >
              {t('cancel', 'Cancel')}
            </Button>
            <Button
              name="continue-button"
              size="large"
              aria-label="mp-dialog-yes-btn"
              onClick={() => {
                removeLayerAndHighlightedCard();
                mergeOverlapRef.current = true;
                setMultiProduct(true);
                handleClose();
                emitMixpanelEvents(MixpanelEventHub.HUB_ORDER_ARCHIVE_MULTI_PRODUCT_TOGGLE, {
                  toggle_status: 'on',
                  accept: 'yes',
                });
              }}
              fullWidth
              variant="contained"
              color="primary"
            >
              {t('yes', 'Yes')}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>

      {/* This is multi product ending */}
      <Dialog
        open={open2}
        keepMounted
        onClose={handleClose2}
        className="skywatch-dialog multiple-overlape-dialogue overlapping-dialog"
        PaperProps={{
          sx: {
            maxWidth: '416px !important',
          },
        }}
      >
        <DialogTitle>{t('getImagesSeparately', 'Get Images separately')}</DialogTitle>
        <IconButton
          aria-label="close"
          className="close-btn"
          onClick={handleClose2}
          sx={{
            position: 'absolute',
            right: 26,
            top: 20,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Typography variant="body1">
            {t(
              'turningOffMultiDesc',
              'Turning off the multi-product mode will allow you to add the images as separate orders. Would you like to proceed?'
            )}
          </Typography>

          <Stack justifyContent="space-evenly" gap={3} direction="row">
            <Button
              name="continue-button"
              size="large"
              onClick={() => {
                handleClose2();
                emitMixpanelEvents(MixpanelEventHub.HUB_ORDER_ARCHIVE_MULTI_PRODUCT_TOGGLE, {
                  toggle_status: 'off',
                  accept: 'cancel',
                });
              }}
              fullWidth
              variant="outlined"
              color="primary"
            >
              {t('cancel', 'Cancel')}
            </Button>
            <Button
              name="continue-button"
              size="large"
              aria-label="mp-end-yes-btn"
              onClick={() => {
                removeLayerAndHighlightedCard();
                mergeOverlapRef.current = false;
                disableSrcRef.current = '';
                disableBandsRef.current = '';
                disableConstellationRef.current = '';
                mergeOverlapPrimaryItemRef.current = false;
                multiProductCartItemRef.current = {};
                setMultiProduct(false);
                handleClose2();
                emitMixpanelEvents(MixpanelEventHub.HUB_ORDER_ARCHIVE_MULTI_PRODUCT_TOGGLE, {
                  toggle_status: 'off',
                  accept: 'yes',
                });
              }}
              fullWidth
              variant="contained"
              color="primary"
            >
              {t('yes', 'Yes')}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
});
